var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list-item-avatar',{attrs:{"size":_vm.avatarSize}},[_c('img',{attrs:{"src":_vm.imagenUrl,"alt":"Image"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }